/**
 * Asynchronously loads the component for Setup2FAForm
 */
import Loadable from 'react-loadable'
import React from 'react'
import LoadingIndicator from '@app/components/LoadingIndicator'

export default Loadable({
  loader: () => import('./index' /* webpackChunkName: "Setup2FAForm" */),
  loading: () => <LoadingIndicator />
})